import { ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';
import { replaceInvalidIriChars } from 'src/utils/removeInvalidIriChars';

const getDefaultProjectPrefix = (project: Pick<Project, 'name'>) =>
  `tag:stardog:designer:${replaceInvalidIriChars(project.name)}:`;

const getDefaultProjectModelPrefix = (
  project: Pick<Project, 'name'>,
  modelName: string
) => `${getDefaultProjectPrefix(project)}${replaceInvalidIriChars(modelName)}:`;

/** "Instance Namespace", with trailing colon */
const getDefaultProjectDataPrefix = (project: Pick<Project, 'name'>) =>
  `${getDefaultProjectPrefix(project)}data:`;

// partial types
type OldProject = {
  name: string;
  namespace: string;
};
type Project = {
  name: string;
  modelNamespace: string;
  dataNamespace: string;
};

/**
 * * on {@link Project} remove `namespace` field
 * * on {@link Project} add `modelNamespace` field defaulted to the previous `project.namespace`
 * * on {@link Project} add `dataNamespace` field defaulted to `tag:stardog:project:${project.id}:data:`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v17 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v17Projects(prevState.projects);
  }

  return nextState;
};

const v17Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, OldProject>
  ).forEach(([projectId, { namespace: oldNamespace, ...project }]) => {
    const modelNamespace =
      oldNamespace === getDefaultProjectPrefix(project)
        ? getDefaultProjectModelPrefix(project, 'model')
        : oldNamespace;
    const dataNamespace = getDefaultProjectDataPrefix(project);

    projectsById[projectId] = {
      ...project,
      modelNamespace,
      dataNamespace,
    };
  });

  return { ...prevProjectsState, projectsById };
};
